<section class="example-container" tabindex="0">
  <table>
    @for (row of gridData; track row.key) {
      <tr [class.selected-row]="row === selectedRow" (click)="select(row)">
        @for (col of gridColumns; track col.header) {
          <td>
            @if (col.header === "isClient" && row.isClient) {
              <ng-container>
                <span
                  [ngClass]="{
                    'is-client': row.isClient === 'Client',
                    'is-handyman': row.isClient === 'Handyman',
                  }"
                  [innerHTML]="row.isClient | highlight: searchTerm"
                >
                </span>
              </ng-container>
            } @else if (col.header === "status") {
              <ng-container>
                <span
                  [ngClass]="{
                    'status-error': row.status === 'Error',
                    'status-imported': row.status === 'Imported',
                    'status-open': row.status === 'Open',
                    'status-other':
                      row.status !== 'Open' &&
                      row.status !== 'Imported' &&
                      row.status !== 'Error',
                  }"
                  [innerHTML]="row.status | highlight: searchTerm"
                >
                </span>
              </ng-container>
            } @else if (col.header === "importStatus") {
              <ng-container>
                <span
                  [ngClass]="{
                    'status-error': row.importStatus === 'Error',
                    'status-imported': row.importStatus === 'Imported',
                    'status-open': row.importstatus === 'Open',
                    'status-other':
                      row.importStatus !== 'Open' &&
                      row.importStatus !== 'Imported' &&
                      row.importStatus !== 'Error',
                  }"
                  [innerHTML]="row.importStatus | highlight: searchTerm"
                >
                </span>
              </ng-container>
            } @else {
              <span
                [innerHTML]="row[col.header] | highlight: searchTerm"
              ></span>
            }
          </td>
        }
      </tr>
    }
  </table>
</section>
